export const TRAIN_ELEMENTS_OFFSET_X = 21
export const TRAIN_INTERACTIVE_OFFSET_X = 6
export const TRAIN_INTERACTIVE_OFFSET_Y = -15

export const ATTENDANCE_BACKGROUND_HEIGHT = 22
export const ATTENDANCE_OFFSET_Y = 11
